import React, { Component } from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-1607">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1608">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1609">
          <div className="col-span-1 md:col-span-2" data-id="element-1610">
            <div className="flex items-center gap-2 mb-4" data-id="element-1611">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-1612">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-1613">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-1614">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-1615">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-1616">
            <h4 className="font-semibold text-white mb-4" data-id="element-1617">Explorar</h4>
            <ul className="space-y-3" data-id="element-1618">
              <li data-id="element-1619">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1620">
                  Inicio
                </Link>
              </li>
              <li data-id="element-1621">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1622">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-1623">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1624">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-1625">
            <h4 className="font-semibold text-white mb-4" data-id="element-1626">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-1627">
              <li data-id="element-1628">
                <Link to="/onboarding" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1629">
                  Únete a NOIZA
                </Link>
              </li>

              <li data-id="element-1630">
                <a href={`https://wa.me/50685316690?text=${encodeURIComponent('Hola, requiero soporte con: _________\n\nNombre del restaurante:\nCorreo electrónico registrado:\nNombre de quien contacta:')}`} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1631">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1632">
          <p className="text-white/30 text-sm" data-id="element-1633">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-1634">
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-1635">
              Términos
            </Link>
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-1636">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}